<!--三列问题(icon+三列布局)-->
<template>
  <div class="message-template clearfix">
    <div class="person-icon"></div>
    <div class="message-container">
      <div class="triangle"></div>
      <div class="message">
        <div class="message-header">亲, 下午好! 您是否需要了解以下问题?</div>
        <div class="split-line"></div>
        <div class="message-body">
          <ul class="question-list clearfix">
            <li v-for="item in content">
              <div class="questions">
                <img :src="item.icon" class="question-icon"/>
                <span>{{item.question}}</span>
              </div>
              <ul>
                <li v-for="i in item.children" data-spm="2260480">
                  <a href="javascript:void(0);" @click="recommendAnswer(i.question, i.answer, i.id)" data-spm-click="gostr=/tulong;locaid=6050;id={{i.id}}">{{i.question}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="split-line"></div>
        <div class="message-footer"><span class="pull-right">若没有想要的, 您也可以直接问我哟~</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return{

      }
    },
    ready() {

    },
    props: {
      content: {
        type: Array
      }
    },
    methods:{
      recommendAnswer(question, answer, id) {
        this.$dispatch('recommend-answer', question, answer, id);
      }
    }
  }
</script>

<style rel="stylesheet/less" lang="less">

</style>



// WEBPACK FOOTER //
// MultiIssues.vue?510cbcea